import type { ReasonToMessageMap } from "../common/types";
import type { UniverseActionUnavailableReason } from "./types";

export const universeReasonToMessageMap: ReasonToMessageMap<UniverseActionUnavailableReason> = {
	ACL_EDITOR_REQUIRED: (count) =>
		count === 1
			? `${count} universe is excluded because the user does not have the necessary permissions to perform this action.`
			: `${count} universes are excluded because the user does not have the necessary permissions to perform this action.`,
	ACL_OWNER_REQUIRED: () => "You are not the owner",
	LINKED_TO_PORTFOLIO: (count) =>
		count === 1
			? `${count} universe is linked to a portfolio and cannot be deleted.`
			: `${count} universes are linked to portfolios and cannot be deleted.`,
	GROUP_UNIVERSE: (count) =>
		count === 1
			? `${count} group universe is excluded from the Bulk Sphere template`
			: `${count} group universes are excluded from the Bulk Sphere template`,
};
